export default __webpack_public_path__ + "dfacbbc4bccc75f9b30e409f36e3f981.woff2";